import React, { useState, useEffect } from "react";
import { colors } from "../../../../../themes/Colors";
import { TabButtonFlatButton } from "../../../../common-components";
import NotificationCard from "../../../components/notifications/notification-card/NotificationCard";

const NotificationPcDisplay = ({
  setLoading,
  setPopUpTitle,
  setToastPop,
  setMessage,
  setRefresh,
  refresh,
  getUserInvites,
  auth,
  invitesArray,
}) => {
  const [tableDisplay, setTableDisplay] = useState("pending");

  const AnswerInvite = async (inviteId, answer) => {
    setLoading(true);

    try {
      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL + "/userInvites/answerInvites",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            id: auth.customerUserData.userId,
            email: auth.customerUserData.email,
            inviteId: inviteId,
            answer: answer,
          }),
        }
      );

      const respnseData = await response.json();

      if (respnseData.shareAccount) {
        setLoading(false);
        setToastPop(true);
        setMessage("You have accepted invite");
        setPopUpTitle("SUCCESS");
        setRefresh(refresh ? false : true);
      } else {
        setPopUpTitle("FAILURE");
        setToastPop(true);
        setMessage("Could not csubmit reply to invite, please contact support");
        setLoading(false);
        setRefresh(refresh ? false : true);
      }
    } catch (err) {
      console.log("error", err);
      setPopUpTitle("FAILURE");
      setToastPop(true);
      setMessage(
        "Could not connect check your connection, if this persist contact support"
      );
      setLoading(false);
      setRefresh(refresh ? false : true);
    }
  };

  useEffect(() => {
    getUserInvites();
  }, [tableDisplay, refresh]);
  return (
    <div
      style={{
        height: "88%",
        maxHeight: 900,
        minHeight: 450,
        width: "94%",
        minWidth: 500,
        maxWidth: 1500,
        backgroundColor: colors.secondaryGrey,
        marginTop: 20,
        borderRadius: 20,
        marginLeft: 5,
        WebkitBoxShadow: "-2px 20px 40px -10px #000000",
        borderStyle: "solid",
        borderWidth: 4,
        borderColor: colors.white,
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        overflow: "hidden",
        position: "relative",
      }}
    >
      <div style={{ position: "fixed", top: 35, display: "flex", zIndex: 2 }}>
        <div style={{ marginLeft: 5 }}>
          <TabButtonFlatButton
            title={"PENDING"}
            backgroundColor={
              tableDisplay === "pending" ? colors.greenLight : colors.white
            }
            textColor={
              tableDisplay === "pending" ? colors.white : colors.greenDark
            }
            onClick={() => setTableDisplay("pending")}
          />
        </div>
        <div style={{ marginLeft: 5 }}>
          <TabButtonFlatButton
            title={"COMPLETE"}
            backgroundColor={
              tableDisplay === "complete" ? colors.greenLight : colors.white
            }
            textColor={
              tableDisplay === "complete" ? colors.white : colors.greenDark
            }
            onClick={() => setTableDisplay("complete")}
          />
        </div>
      </div>
      <div
        style={{
          height: "99%",
          width: "100%",

          overflowY: "scroll",
          overflowX: "hidden",
          scrollbarWidth: "none",
        }}
      >
        {tableDisplay === "pending"
          ? invitesArray
            ? invitesArray.map((invite, index) => {
                return invite.status === "Pending" ? (
                  <div key={index} style={{ width: "100%" }}>
                    <NotificationCard
                      status={invite.status}
                      title={invite.linkedBrand}
                      description={
                        "You have been invited by " +
                        " " +
                        invite.createdBy +
                        ", as a " +
                        " " +
                        invite.roles[0] +
                        " User, if you recognise this request and have shared your link pin with them please accept.."
                      }
                      onAcceptClick={() => AnswerInvite(invite._id, "ACCEPTED")}
                      onDeclineClick={() =>
                        AnswerInvite(invite._id, "DECLINED")
                      }
                    />
                  </div>
                ) : null;
              })
            : null
          : null}
        {tableDisplay === "complete"
          ? invitesArray
            ? invitesArray.map((invite, index) => {
                return invite.status !== "Pending" ? (
                  <div key={index} style={{ width: "100%" }}>
                    <NotificationCard
                      title={invite.linkedBrand}
                      status={invite.status}
                      description={
                        "You have been invited by " +
                        " " +
                        invite.createdBy +
                        ", as a " +
                        " " +
                        invite.roles[0] +
                        " User, if you recognise this request and have shared your link pin with them please accept.."
                      }
                    />
                  </div>
                ) : null;
              })
            : null
          : null}
      </div>
    </div>
  );
};

export default NotificationPcDisplay;
